import PubSub from 'pubsub-js';

const LEGACY_STORAGE_KEY = 'smartedi_selected_items';
const ITEMS_INDEX_BODY_CLASS = 'items-page_index';
const SELECTION_CHANGED_TOPIC = 'item.selector';

let items = [];
let navigationListenerRegistered = false;

function isItemsIndexPage() {
  return document.body && document.body.classList.contains(ITEMS_INDEX_BODY_CLASS);
}

function isItemsIndexUrl(url) {
  try {
    const path = new URL(url, window.location.origin).pathname.replace(/\/$/, '');
    return path === '/items' || path === '/items/search';
  } catch (e) {
    return false;
  }
}

function isBrowserReloadNavigation() {
  const nav = performance.getEntriesByType('navigation')[0];
  if (nav && nav.type === 'reload') return true;

  const legacy = performance.navigation;
  if (legacy && typeof legacy.type === 'number' && legacy.type === legacy.TYPE_RELOAD) return true;

  return false;
}

function clearOnBrowserReloadIfItemsIndexPage() {
  if (!isItemsIndexPage()) return;
  if (!isBrowserReloadNavigation()) return;

  selectionStore.clear();
  PubSub.publish(SELECTION_CHANGED_TOPIC, { source: 'browser-reload' });
}

function registerNavigationListeners() {
  if (navigationListenerRegistered) return;
  navigationListenerRegistered = true;

  document.addEventListener('turbolinks:before-visit', (event) => {
    if (isItemsIndexPage() && !isItemsIndexUrl(event.data.url)) {
      selectionStore.clear();
    }
  });
}

const selectionStore = {
  getAll() {
    return items.slice();
  },

  add(item) {
    if (!items.some((i) => i.uuid === item.uuid)) {
      items.push(item);
    }
  },

  remove(uuid) {
    items = items.filter((i) => i.uuid !== uuid);
  },

  has(uuid) {
    return items.some((i) => i.uuid === uuid);
  },

  clear() {
    items = [];
  },

  count() {
    return items.length;
  }
};

registerNavigationListeners();

try {
  localStorage.removeItem(LEGACY_STORAGE_KEY);
} catch (e) {
  // ignore storage access errors
}

export default selectionStore;
export { clearOnBrowserReloadIfItemsIndexPage, isBrowserReloadNavigation };
